import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import 'codemirror/lib/codemirror.css';
import CodeMirror from './CodeMirror';
import './index.css';

var ReactCodeMirror = /*#__PURE__*/function (_Component) {
  _inherits(ReactCodeMirror, _Component);

  function ReactCodeMirror(props) {
    var _this;

    _classCallCheck(this, ReactCodeMirror);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReactCodeMirror).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "getInstance", function (instance) {
      if (instance) {
        _this.codemirror = instance.codemirror;
        _this.editor = instance.editor;
      }
    });

    _this.state = {
      codeMirrorOptions: {}
    };
    return _this;
  }

  _createClass(ReactCodeMirror, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var options, codeMirrorOptions;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                options = this.props.options;
                codeMirrorOptions = Object.assign({
                  tabSize: 2,
                  autoCloseBrackets: true,
                  matchBrackets: true,
                  showCursorWhenSelecting: true,
                  // 显示行号
                  lineNumbers: true,
                  fullScreen: true
                }, options);
                this.setState({
                  codeMirrorOptions: codeMirrorOptions
                });

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "componentWillReceiveProps",
    value: function () {
      var _componentWillReceiveProps = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(nextPros) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.setState({
                  codeMirrorOptions: Object.assign({}, this.state.codeMirrorOptions, {}, nextPros.options)
                });

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function componentWillReceiveProps(_x) {
        return _componentWillReceiveProps.apply(this, arguments);
      }

      return componentWillReceiveProps;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          options = _this$props.options,
          otherProps = _objectWithoutProperties(_this$props, ["options"]);

      var codeMirrorOptions = this.state.codeMirrorOptions;
      return React.createElement(CodeMirror, _extends({}, otherProps, {
        ref: this.getInstance,
        options: Object.assign({}, codeMirrorOptions)
      }));
    }
  }]);

  return ReactCodeMirror;
}(Component);

export { ReactCodeMirror as default };
ReactCodeMirror.defaultProps = {
  value: '',
  options: {}
};
ReactCodeMirror.propTypes = {
  value: PropTypes.string,
  options: PropTypes.object
};